export function getIconUrl(id, time = '') {
  const t = time ? `?t=${time}` : ''
  return `/api/v1/img/point-icons/${id}${t}`
}

export function getIconOptions(pointIcon, isActive = false, scale = 1) {
  scale *= isActive ? 1.25 : 1
  const options = {
    iconUrl: getIconUrl(pointIcon.id, pointIcon.file_updated_at),
    iconSize: [pointIcon.width * scale, pointIcon.height * scale],
    iconAnchor: [pointIcon.anchor_x * scale, pointIcon.anchor_y * scale],
    className: `fpm-marker${isActive ? ' fpm-marker_active' : ''}`
  }

  return options
}
